import SpacesExportOptionsModalView from "./spaces-export-options.html";
import SpacesEditModalView from "./spaces-edit.html";
import TemplateSpaceModalView from "./templateModal.html";

angular.module("events")

    .controller("EventsSpacesListCtrl", ['$location', 'clipboard', 'event', '$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', 'generateDocumentService', 'logService',
        function ($location, clipboard, event, $rootScope, $scope, $http, $interval, $q, i18nService, Restangular, gridService, modalService, $uibModal, $filter, $translate, generateDocumentService, logService) {        
         $scope.event = event;          
        
        $rootScope.title = $filter('translate')('spaces.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('spaces.title') + " / " + event.name }
        ];

        $scope.gridOptionsSpaces = {
            pdfTitle: "Espacios",
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            enableSorting: true,            
            paginationPageSizes: [20, 40, 60],
            paginationPageSize: 20,
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
              { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
              { name: 'name', displayName: $filter('translate')('spaces.name'), enableFiltering: true, enableHiding: false },
              {
                  name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                    { title: $filter('translate')('spaces.button_export'), action: 'ng-click="grid.appScope.showExportSpaceToExcel(row.entity.id)"', cssIconClass: "fas fa-file-excel" },
                    { title: $filter('translate')('spaces.button_preview'), action: 'ng-click="grid.appScope.openImage(row.entity.id)"', cssIconClass: "fa fa-image" },
                    { title: $filter('translate')('inscriptions_forms.copy_url'), action: 'ng-click="grid.appScope.copyToClipboard(row.entity.id)"', cssIconClass: "fa fa-link" },
                    { title: $filter('translate')('spaces.button_print_full_space'), action: 'ng-click="grid.appScope.printDialog(\'SPACE_FULL_PLAN\',row.entity.id)"', cssIconClass: "fa fa-file" },
                    { title: $filter('translate')('spaces.button_print_space'), action: 'ng-click="grid.appScope.printDialog(\'SPACE_GUESTS\',row.entity.id)"', cssIconClass: "fa fa-file" },
                    { title: $filter('translate')('spaces.button_print_locations'), action: 'ng-click="grid.appScope.printDialog(\'GUEST_LOCATION\',row.entity.id)"', cssIconClass: "fa fa-building-o" },
                    { title: $filter('translate')('general.button_edit'), action: 'ng-click="grid.appScope.editSpace(row.entity.id)"', cssIconClass: "fa fa-edit" },
                    { title: $filter('translate')('general.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);"', cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right" })
              },
            ],
            getData: function (options) {
                options.event_id = $scope.event.id;
                return Restangular.all('EventsSpaces').getList(options);
            }
        };

        $scope.copyToClipboard = function (uid) {
            clipboard.copyText($location.host() + '/#/dashboard_space/show/' + $scope.event.id + '/' + uid);
        };

        $scope.openImage = function (uid) {
            window.open('/api/eventsspaces/' + uid + '/image', '_blank');
        };

        $scope.showExportSpaceToExcel = function (id) {
            const modalInstance = $uibModal.open({
                template: SpacesExportOptionsModalView,
                controller: ['$scope', '$uibModalInstance', function($scope, $uibModalInstance){
                    $scope.options = {
                        single_sheet: false
                    };
                    $scope.ok = function(){
                        $uibModalInstance.close($scope.options);
                    }
                    $scope.cancel = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                }],
                scope: $scope
            });
            modalInstance.result.then(function (options) {
                logService.log(options);
                $scope.exportSpaceToExcel(id, options.single_sheet);
            }, function () {
                //dimissed
            });
        }

        $scope.exportSpaceToExcel = function (id, single_sheet) {
            window.open('/api/eventsspaces/' + id + '/excel?single_sheet=' + (single_sheet?"true":"false"), '_blank');
        };

        $scope.editSpace = function (id) {
            logService.debug("Open", id);
            if (id != null) {
                const modalInstance = $uibModal.open({
                    template: SpacesEditModalView,
                    controller: "EventsSpacesEditCtrl",
                    size: "fullscreen",
                    scope: $scope,
                    backdrop: 'static',
                    resolve: {
                        id: function () {
                            return id;
                        },
                        configuration: function () {
                            return "";
                        },
                        name: function () {
                            return "";
                        }
                    }
                });

                modalInstance.result.then(function (options) {
                    logService.log(options);
                }, function () {
                    //dimissed
                });
            } else {
                //TEMPLATE
                let $modalInstanceTemplate = $uibModal.open({
                    animation: true,
                    template: TemplateSpaceModalView,
                    size: "md",
                    controller: "TemplateSpaceModalCtrl"
                });
                //Response del modal
                $modalInstanceTemplate.result.then(function (idTemplate) {
                    if (idTemplate != null) {
                        Restangular.one('Spaces', idTemplate).get().then(function (results) {
                            logService.debug(results);
                            var modalInstance = $uibModal.open({
                                template: SpacesEditModalView,
                                controller: "EventsSpacesEditCtrl",
                                size: "fullscreen",
                                scope: $scope,
                                backdrop: 'static',
                                resolve: {
                                    id: function () {
                                        return null;
                                    },
                                    configuration: function () {
                                        return results.configuration;
                                    },
                                    name: function () {
                                        return results.name;
                                    }
                                }
                            });

                            modalInstance.result.then(function (options) {
                            }, function () {
                                //dimissed
                            });
                        });
                    } else {
                        var modalInstance = $uibModal.open({
                            template: SpacesEditModalView,
                            controller: "EventsSpacesEditCtrl",
                            size: "fullscreen",
                            scope: $scope,
                            backdrop: 'static',
                            resolve: {
                                id: function () {
                                    return null;
                                },
                                configuration: function () {
                                    return "";
                                },
                                name: function () {
                                    return "";
                                }
                            }
                        });

                        modalInstance.result.then(function (options) {
                        }, function () {
                            //dimissed
                        });
                    }
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                });
            }
        };

        $scope.deleteDialog = function (id, name) {
            modalService.confirm({
                title: $filter('translate')('spaces.delete'),
                message: $filter('translate')('spaces.delete_message')+" " + name + "?",
                onAccept: function () {
                    Restangular.one('EventsSpaces', id).remove().then(function () {
                        toastr.success($filter('translate')('spaces.delete_success'));
                        $scope.gridOptionsSpaces.gridApi.core.raise.itemDeleted($scope);
                        
                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };
        /**
           * CODE: codigo del documents_types
           * TYPE_DOCUMENT: pdf/html
           * TYPE_RESULT: list/single  si es list, no tendra id, si es single, es que sólo se va a pintar un resultado, por lo tanto hay que poner el id de lo que se quiere mostrar.
           **/
            $scope.printDialog = function (code, event_space_id) {
                var params = {
                    entity_type: "events",
                    entity_type_id: $scope.event.id,
                    documents: { codes: [code] }
                };
                logService.debug(params);
                generateDocumentService.documentNew({
                    params: params,
                    onAccept: function (data) {
                        angular.forEach(data, function (item) {
                            //url = (window as any).CONFIG.api_url + 'documentgenerator/' + item.document_url_method + '/' + item.document_id + '/' + params.entity_type_id + "/" + event_space_id + '/pdf';
                            //window.open(url, '_blank');
                            $http({
                                method: 'post',
                                url: (window as any).CONFIG.api_url + 'documentgenerator/Generate',
                                params: { document_id: item.document_id, event_id: params.entity_type_id, event_space_id: event_space_id, outputType: 'pdf' }

                            }).then(function (result, status, headers, config) {
                                var url = (window as any).CONFIG.api_url + 'documentgenerator/download/' + result.data;
                                window.open(url, '_blank');
                            });
                        })

                    }
                });    
            }
        
        }])

    .controller("TemplateSpaceModalCtrl", ['$scope', '$uibModalInstance', 'Restangular', 'logService', function ($scope, $uibModalInstance, Restangular, logService) {

        let options = {}; 
        Restangular.all('Spaces').getList(options).then(function (response) {
            $scope.templates = response;
        })
        

        $scope.createFromTemplate = function (id) {
            logService.debug(id);
            $uibModalInstance.close(id);
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
        $scope.delete = function () {
            $scope.deleteObject($scope.item);
            $uibModalInstance.dismiss('deleted');
        };
    }])
;